// Card Variant Picker Enhancement
// Ensures proper integration with Shopify's variant selection system

document.addEventListener('DOMContentLoaded', function() {
  console.log('Card Variant Picker: DOM loaded');
  
  // Trigger variant update for impact options that have 2nd option pre-selected
  setTimeout(function() {
    const impactFieldsets = document.querySelectorAll('.card-variant-picker__fieldset--impact');
    impactFieldsets.forEach(fieldset => {
      const checkedInput = fieldset.querySelector('input:checked');
      if (checkedInput) {
        console.log('Card Variant Picker: Triggering initial variant update for impact option:', checkedInput.value);
        // Dispatch change event to update the variant
        const changeEvent = new Event('change', { bubbles: true });
        checkedInput.dispatchEvent(changeEvent);
      }
    });
  }, 200);
  
  // Listen for variant changes to update card picker display
  document.addEventListener('variant:changed', function(event) {
    console.log('Card Variant Picker: Variant changed', event.detail.variant);
    const variant = event.detail.variant;
    updateCardPickerDisplay(variant);
  });

  // Debug: Check if variant-selects element exists
  const variantSelects = document.querySelector('variant-selects.card-variant-picker');
  if (variantSelects) {
    console.log('Card Variant Picker: Found variant-selects element', variantSelects);
    
    // Add debug listener to see if change events are firing
    variantSelects.addEventListener('change', function(event) {
      console.log('Card Variant Picker: Change event fired', event.target);
      console.log('Card Variant Picker: Selected value', event.target.value);
      console.log('Card Variant Picker: Form ID', event.target.form);
      
      // Find the product form and check if the variant ID is being updated
      const productForm = event.target.form;
      if (productForm) {
        const variantIdInput = productForm.querySelector('input[name="id"]');
        console.log('Card Variant Picker: Product form found', productForm);
        console.log('Card Variant Picker: Form ID', productForm.id);
        console.log('Card Variant Picker: Variant ID input', variantIdInput);
        console.log('Card Variant Picker: Current variant ID', variantIdInput ? variantIdInput.value : 'not found');
      } else {
        console.log('Card Variant Picker: No form found for input');
      }
    });
  } else {
    console.log('Card Variant Picker: No variant-selects element found');
  }

  // Function to update card picker display when variant changes
  function updateCardPickerDisplay(variant) {
    const cardVariantPickers = document.querySelectorAll('.card-variant-picker');
    
    cardVariantPickers.forEach(picker => {
      // Update availability display
      const options = picker.querySelectorAll('.card-variant-picker__option');
      options.forEach(option => {
        const input = option.previousElementSibling;
        const unavailableElement = option.querySelector('.card-variant-picker__unavailable');
        
        if (input && input.disabled) {
          option.classList.add('card-variant-picker__option--disabled');
          if (unavailableElement) {
            unavailableElement.style.display = 'block';
          }
        } else {
          option.classList.remove('card-variant-picker__option--disabled');
          if (unavailableElement) {
            unavailableElement.style.display = 'none';
          }
        }
      });
    });
  }

  // Add click analytics for card variant picker and direct variant updating
  const cardVariantInputs = document.querySelectorAll('.card-variant-picker__input');
  cardVariantInputs.forEach(input => {
    input.addEventListener('change', function() {
      console.log('Card Variant Picker: Input changed', this.name, this.value);
      
      // Track variant selection
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'variant_selected',
          'variant_option': this.name,
          'variant_value': this.value
        });
      }
      
      // Force variant update by triggering the variant-selects change event
      const variantSelectsElement = this.closest('variant-selects');
      if (variantSelectsElement) {
        console.log('Card Variant Picker: Triggering variant-selects change');
        
        // Create a synthetic change event to trigger the variant selection system
        const changeEvent = new Event('change', { bubbles: true });
        variantSelectsElement.dispatchEvent(changeEvent);
        
        // Also manually update the variant if needed
        setTimeout(() => {
          updateVariantDirectly(variantSelectsElement);
        }, 100);
      }
    });
  });
  
  // Function to directly update variant when automatic system fails
  function updateVariantDirectly(variantSelectsElement) {
    try {
      console.log('Card Variant Picker: Attempting direct variant update');
      
      // Get selected option values
      const selectedInputs = variantSelectsElement.querySelectorAll('fieldset input:checked');
      const selectedValues = Array.from(selectedInputs).map(input => input.value);
      
      console.log('Card Variant Picker: Selected values', selectedValues);
      
      // Get product data
      const productDataScript = variantSelectsElement.querySelector('script[data-selected-variant]');
      if (!productDataScript) {
        console.log('Card Variant Picker: No product data found');
        return;
      }
      
      const currentVariant = JSON.parse(productDataScript.textContent);
      console.log('Card Variant Picker: Current variant', currentVariant);
      
      // Find matching variant based on selected options
      const sectionId = variantSelectsElement.dataset.section;
      const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
      
      if (productInfo) {
        console.log('Card Variant Picker: Found product-info element');
        
        // Try to fetch variant data from the product
        const productUrl = variantSelectsElement.dataset.url;
        if (productUrl && selectedValues.length > 0) {
          fetchVariantByOptions(productUrl, selectedValues, sectionId);
        }
      }
    } catch (error) {
      console.error('Card Variant Picker: Error in direct variant update', error);
    }
  }
  
  // Function to fetch variant by selected options
  async function fetchVariantByOptions(productUrl, selectedValues, sectionId) {
    try {
      console.log('Card Variant Picker: Fetching variant for options', selectedValues);
      
      // Get the variant selects element to find option names
      const variantSelectsElement = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
      if (!variantSelectsElement) {
        console.log('Card Variant Picker: No variant-selects element found');
        return;
      }
      
      // Get option names from fieldsets
      const fieldsets = variantSelectsElement.querySelectorAll('fieldset');
      const searchParams = new URLSearchParams();
      
      // Build URL with actual option names
      selectedValues.forEach((value, index) => {
        if (fieldsets[index]) {
          // Get the option name from the input name attribute
          const firstInput = fieldsets[index].querySelector('input[type="radio"]');
          if (firstInput && firstInput.name) {
            // Extract option name from "options[Option Name]" format
            const optionNameMatch = firstInput.name.match(/options\[(.*?)\]/);
            if (optionNameMatch) {
              const optionName = optionNameMatch[1];
              searchParams.append(optionName, value);
              console.log(`Card Variant Picker: Adding ${optionName}=${value}`);
            }
          }
        }
      });
      
      const url = `${productUrl}?${searchParams.toString()}`;
      console.log('Card Variant Picker: Fetching from URL', url);
      
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extract variant data from response
      const variantScript = doc.querySelector('variant-selects script[data-selected-variant]');
      if (variantScript) {
        const variant = JSON.parse(variantScript.textContent);
        console.log('Card Variant Picker: Found variant from fetch', variant);
        
        // Verify this is the right variant by checking if options match
        const optionsMatch = selectedValues.every((value, index) => {
          const variantOption = variant[`option${index + 1}`];
          return variantOption === value;
        });
        
        if (optionsMatch) {
          console.log('Card Variant Picker: Variant options match, updating');
          // Update the variant ID in the product form
          updateProductFormVariant(variant.id, sectionId);
          
          // Dispatch variant changed event
          document.dispatchEvent(new CustomEvent('variant:changed', {
            detail: { variant: variant }
          }));
        } else {
          console.log('Card Variant Picker: Variant options do not match, trying direct lookup');
          // Try direct variant lookup by matching options
          findVariantByOptions(selectedValues, sectionId);
        }
      } else {
        console.log('Card Variant Picker: No variant script found in response');
        // Try direct variant lookup by matching options
        findVariantByOptions(selectedValues, sectionId);
      }
    } catch (error) {
      console.error('Card Variant Picker: Error fetching variant', error);
      // Try direct variant lookup by matching options
      findVariantByOptions(selectedValues, sectionId);
    }
  }
  
  // Function to find variant by directly matching options from product data
  function findVariantByOptions(selectedValues, sectionId) {
    try {
      console.log('Card Variant Picker: Attempting direct variant lookup for', selectedValues);
      
      // Get product data from window.productVariants or similar
      const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
      if (!productInfo) {
        console.log('Card Variant Picker: No product-info found');
        return;
      }
      
      // Look for product data in various places
      let productData = null;
      
      // Try to find product variants data
      const productScripts = document.querySelectorAll('script[type="application/json"]');
      for (const script of productScripts) {
        try {
          const data = JSON.parse(script.textContent);
          if (data && Array.isArray(data) && data[0] && data[0].id && data[0].options) {
            // This looks like variants data
            productData = data;
            console.log('Card Variant Picker: Found product variants data', data.length, 'variants');
            break;
          }
        } catch (e) {
          // Continue searching
        }
      }
      
      if (!productData) {
        console.log('Card Variant Picker: No product variants data found');
        return;
      }
      
      // Find matching variant
      const matchingVariant = productData.find(variant => {
        return selectedValues.every((value, index) => {
          const variantOption = variant.options[index];
          return variantOption === value;
        });
      });
      
      if (matchingVariant) {
        console.log('Card Variant Picker: Found matching variant by direct lookup', matchingVariant);
        
        // Update the variant ID in the product form
        updateProductFormVariant(matchingVariant.id, sectionId);
        
        // Dispatch variant changed event
        document.dispatchEvent(new CustomEvent('variant:changed', {
          detail: { variant: matchingVariant }
        }));
      } else {
        console.log('Card Variant Picker: No matching variant found');
      }
    } catch (error) {
      console.error('Card Variant Picker: Error in direct variant lookup', error);
    }
  }
  
  // Function to update product form variant ID
  function updateProductFormVariant(variantId, sectionId) {
    const productForm = document.querySelector(`#product-form-${sectionId}`);
    if (productForm) {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      if (variantIdInput) {
        console.log('Card Variant Picker: Updating variant ID from', variantIdInput.value, 'to', variantId);
        variantIdInput.value = variantId;
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // Ensure proper form submission
  const cardVariantPickers = document.querySelectorAll('.card-variant-picker');
  cardVariantPickers.forEach(picker => {
    picker.addEventListener('change', function(event) {
      // Ensure the variant selection is properly reflected in the form
      const productForm = event.target.form;
      if (productForm) {
        const variantIdInput = productForm.querySelector('input[name="id"]');
        if (variantIdInput) {
          console.log('Card Variant Picker: Form submission check - variant ID:', variantIdInput.value);
          // Trigger form validation if needed
          const submitButton = productForm.querySelector('button[type="submit"]');
          if (submitButton) {
            // Remove any error states
            submitButton.classList.remove('btn--error');
            submitButton.removeAttribute('disabled');
            console.log('Card Variant Picker: Submit button state updated');
          }
        }
      } else {
        console.log('Card Variant Picker: No form found for form submission check');
      }
    });
  });
});

// CSS class utilities for card variant picker
const CardVariantPickerUtils = {
  // Toggle loading state
  setLoading: function(picker, isLoading) {
    if (isLoading) {
      picker.classList.add('card-variant-picker--loading');
    } else {
      picker.classList.remove('card-variant-picker--loading');
    }
  },

  // Update option availability
  updateOptionAvailability: function(picker, availableOptions) {
    const options = picker.querySelectorAll('.card-variant-picker__option');
    options.forEach(option => {
      const input = option.previousElementSibling;
      const value = input.value;
      const isAvailable = availableOptions.includes(value);
      
      input.disabled = !isAvailable;
      option.classList.toggle('card-variant-picker__option--disabled', !isAvailable);
      
      const unavailableElement = option.querySelector('.card-variant-picker__unavailable');
      if (unavailableElement) {
        unavailableElement.style.display = isAvailable ? 'none' : 'block';
      }
    });
  }
};

// Export for use in other scripts
window.CardVariantPickerUtils = CardVariantPickerUtils; 